import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { AuthService } from 'src/app/features/pages/authmanagement/services/Auth.service';
import { LocalStorageService } from 'src/app/features/shared/services/LocalStorage.service';

@Component({
  selector: 'dashboard-sidebar',
  templateUrl: './dashboard-sidebar.component.html',
  styleUrls: ['./dashboard-sidebar.component.css']
})
export class DashboardSidebarComponent {
  @Input() selectedMonth: string = '';
  @Input() selectedDate: Date = null;
  @Output() monthSelected = new EventEmitter<number>();

  userName: string = "";
  userEmail: string = "";
  regularName: string = "";

  months: { name: string, value: number, selected: boolean }[] = [
    { name: 'Enero', value: 1, selected: true },
    { name: 'Febrero', value: 2, selected: false },
    { name: 'Marzo', value: 3, selected: false },
    { name: 'Abril', value: 4, selected: false },
    { name: 'Mayo', value: 5, selected: false },
    { name: 'Junio', value: 6, selected: false },
    { name: 'Julio', value: 7, selected: false },
    { name: 'Agosto', value: 8, selected: false },
    { name: 'Septiembre', value: 9, selected: false },
    { name: 'Octubre', value: 10, selected: false },
    { name: 'Noviembre', value: 11, selected: false },
    { name: 'Diciembre', value: 12, selected: false }
  ];

  constructor(private localStorageService: LocalStorageService, public authService: AuthService) { }

  ngOnInit(): void {
    const now = new Date();
    const currentMonth = now.getMonth() + 1;

    var userString = this.localStorageService.getUserName();
    if (userString != null && userString != undefined && userString != '') {
      this.userName = userString;
    }

    var regularName = this.localStorageService.getRegularName();
    if (regularName != null && regularName != undefined && regularName != '') {
      this.regularName = regularName;
    }

    if (this.userName && !this.userEmail) {
      this.userEmail = this.userName;
    }

    if (!isNaN(currentMonth) && currentMonth >= 1 && currentMonth <= 12) {
      this.months = this.months.filter(month => month.value <= currentMonth);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedMonth']) {
      const monthValue = parseInt(this.selectedMonth);
      this.months.forEach(month => {
        month.selected = false;
      });
      this.months.find(month => month.value === monthValue).selected = true;
    }
  }

  onMonthClick(monthValue: number): void {
    this.months.forEach(month => {
      month.selected = false;
    });
    this.months.find(month => month.value === monthValue).selected = true;
    this.monthSelected.emit(monthValue);
  }
}
